import { Grid, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import "./gridControls.scss";

const FirstColumnPointer = (props) => {
  return (
    <div className="grid-container">
      <Tooltip title={props.value} arrow placement="right-start" >
        <Typography
          className="first-column-pointer"
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "left",
            color: "#152C73",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            cursor: "pointer"
          }}
          onClick={props.action}
        >
          {props.value}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default FirstColumnPointer;
